import React from 'react';
import buildABase from '../img/buildabase.svg'

const BuildABase = () => (
  <img src={buildABase} alt="Base image" />
);

export default BuildABase;